import React from "react"
import "./_style.scss"

import TileContentPerson from "§/src/components/atoms/content/tile-content-person"

const PeopleGrid = ({ title, items, ...props }) => {
  const compClassName = "people-grid"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName

  return (
    <div comp={compClassName} className={compClass}>
      <div className="d-flex flex-column gap-3">
        <div className="fs-14 mb-0">{title}</div>
        <div className={"people"}>
          {items &&
            items?.map((item, index) => {
              return (
								<React.Fragment key={"item-people-grid-" + index}>
									{ (index > 0 && index % 3 == 0) && (
										<hr/>
									)}
									<TileContentPerson
										name={item?.name}
										title={item?.role}
										image={item?.image}
										content={item?.description}
									/>
                </React.Fragment>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default PeopleGrid
